<template>
    <div>
        <div class="leaderBox" v-if="showOrhide">
            <div class="newtext">新手指引</div>
            <img src="../../assets/images/maskClose.png" class="closeIt" @click="closeIt">
            <img src="../../assets/images/caigou1.png" class="steps step1" v-if="status==1">
            <img src="../../assets/images/caigou2.png" class="steps step2" v-if="status==2">
            <img src="../../assets/images/caigou3.png" class="steps step3" v-if="status==3">
            <div class="stepbtn" @click="nextStep(status)">
                {{status==1?"下一步":status==2?"下一步":status==3?"我知道了":"我知道了"}}
            </div>
            <div class="bottomTip">
                <el-checkbox v-model="checked">下次不再提示</el-checkbox>
            </div>
        </div>
        <breadcrumb :routerList="[{to:'/dingd/purchaselist',title:'订单管理'},{title:'新建采购订单'}]"/>

        <div class="h-content">
            <div class="h-row h-mrt0">
                <div class="h-rowIn">
                    <div class="h-rowBox">
                        <el-form
                                :model="zy"
                                label-position="right"
                                ref="form1"
                                :rules="rules"
                                :inline="true"
                                class="demo-ruleForm h-formbLine h-formbLine1">
                            <div class="h-rowCon">


                                <div class="h-pieceIn2">
                                    <!-- <div style="height:30px;color:#303030;font-size:0.18rem;margin-bottom:20px;border-bottom:1px solid #dadfe0;font-weight:600">新增需求</div> -->
                                    <div class="h-pieceTitle2" style="margin-bottom: 0.3rem;">
                                        <h1>基本信息</h1>
                                    </div>
                                    <div class="h-pieceCon2">
                                        <div class="h-formLine dingdan2">
                                            <el-form-item label="订单总价" class="h-elformWrap-2">
                                                <el-input readonly placeholder="自带出" v-model="zy.totalPrice"
                                                          type="number"></el-input>
                                            </el-form-item>
                                            <el-form-item label="期望到货时间" class="h-elformWrap-2" prop="expectDate">
                                                <div class="block">
                                                    <el-date-picker
                                                            v-model="zy.expectDate"
                                                            type="datetime"
                                                            placeholder="--选择--">
                                                    </el-date-picker>
                                                </div>
                                            </el-form-item>
                                            <el-form-item label="采购组" class="h-elformWrap-2" prop="cgGroupCode">
                                                <mdmselect
                                                        clearable
                                                        category="YLPurchaseGroup"
                                                        :v="zy.cgGroupCode"
                                                        v-model="zy.cgGroupCode">
                                                </mdmselect>
                                            </el-form-item>
											<el-form-item label="采购组织" class="h-elformWrap-2" prop="purchaseOrgCode">
											    <brselect
											            clearable
                                                        @change="changeCgGroup"
											            category="purchase_org_code"
											            :v="zy.purchaseOrgCode"
											            v-model="zy.purchaseOrgCode">
											    </brselect>
											</el-form-item>
                                            <el-form-item label="收货仓库" prop="warehouse" v-if="ckFlag" class="h-elformWrap-2">
                                                <el-select v-model="zy.warehouse" :clearable="true" @change="changeWarehouse"
                                                           placeholder="请选择">
                                                    <el-option label="青岛库" value="青岛库"></el-option>
                                                    <el-option label="苏州库" value="苏州库"></el-option>
                                                </el-select>
                                            </el-form-item>
                                        </div>
                                    </div>
                                </div>


                                <div class="h-pieceIn2">
                                    <!-- <div style="height:30px;color:#303030;font-size:0.18rem;margin-bottom:20px;border-bottom:1px solid #dadfe0;font-weight:600">新增需求</div> -->
                                    <div class="h-pieceTitle2" style="margin-bottom: 0.3rem;">
                                        <h1>物流信息</h1>
                                    </div>
                                    <div class="h-pieceCon2">
                                        <div class="h-formLine dingdan2">
                                            <el-form-item label="物流类型" class="h-elformWrap-2" prop="waybillType">
                                                <el-select
                                                        v-model="zy.waybillType"
                                                        placeholder="请选择">
                                                    <el-option
                                                            v-for="(item,index4) in options1"
                                                            :key="index4"
                                                            :label="item.name"
                                                            :value="item.code">
                                                    </el-option>
                                                </el-select>
                                            </el-form-item>
                                            <el-form-item label="接收人" class="h-elformWrap-2" prop="receiver">
                                                <el-input placeholder="请输入" v-model="zy.receiver"></el-input>
                                            </el-form-item>
                                            <el-form-item label="接收人手机号" class="h-elformWrap-2" prop="receverPhone">
                                                <el-input placeholder="请输入" v-model="zy.receverPhone"></el-input>
                                            </el-form-item>
                                            <el-form-item label="收货单位" class="h-elformWrap-2" prop="receiveUnit">
                                                <el-input placeholder="请输入" v-model="zy.receiveUnit"></el-input>
                                            </el-form-item>
                                            <el-form-item label="收货地址" class="h-elformWrap-2" prop="detailAddress">
                                                <el-input clearable v-model="zy.detailAddress" readonly
                                                          style="width:500px;">
                                                    <i
                                                            class="el-icon-search el-input__icon"
                                                            slot="suffix"
                                                            @click="selectAreadialog">
                                                    </i>
                                                </el-input>
                                            </el-form-item>
                                        </div>
                                    </div>
                                </div>


                                <div class="N-chan">
                                    <div class="h-pieceTitle2">
                                        <h1>型号信息</h1>
                                    </div>
                                    <div class="yxtable ljjtable">
                                        <el-table
                                                ref="multipleTable"
                                                :data="tableData3"
												border
                                                style="width: 100%"
                                        >
                                            <el-table-column
                                                    type="index"
                                                    width="40"
                                                    label="#">
                                            </el-table-column>
                                            <el-table-column
                                                    prop="productCate"
                                                    label="产品大类"
													:show-overflow-tooltip="true"
                                                    width="140">
                                                <template slot-scope="scope">
                                                    {{scope.row.productCate | dictname('product_level')}}
                                                </template>
                                            </el-table-column>
											<el-table-column
											        prop="productDes"
											        label="产品型号"
													:show-overflow-tooltip="true"
											        min-width="180">
													<template slot-scope="scope">
														<div style="text-align: left;">
															{{scope.row.productDes}}
														</div>
													</template>
											</el-table-column>
                                            <el-table-column
                                                    prop="productNo"
                                                    label="产品编码"
													:show-overflow-tooltip="true"
                                                    width="180">
                                            </el-table-column>

                                            <el-table-column
                                                    prop="suserCode"
                                                    label="供应商名称"
                                                    width="240"
                                            >
                                                <template slot-scope="scope">

                                                    <el-select
                                                            v-model="scope.row.suserCode"
                                                            placeholder="请选择"
                                                            filterable
                                                            @change="changeSup(scope.row)">
                                                        <el-option
                                                                v-for="(item,index3) in scope.row.options2"
                                                                :key="index3"
                                                                :label="item.finalSupplierName"
                                                                :value="item.finalSupplier">
                                                        </el-option>
                                                    </el-select>

                                                </template>

                                            </el-table-column>
                                            <el-table-column
                                                    prop="unitPrice"
                                                    label="产品单价"
                                                    width="140">
                                                <template slot-scope="scope">
                                                    <el-input readonly placeholder="自带出"
                                                              v-model="scope.row.unitPrice"></el-input>
                                                </template>
                                            </el-table-column>
                                            <el-table-column
                                                    prop="count"
                                                    label="产品数量"
													:show-overflow-tooltip="true"
                                                    width="130">
														<template slot-scope="scope">
															<div style="text-align: right;">
																{{scope.row.count}}
															</div>
														</template>
                                            </el-table-column>
                                            <el-table-column
                                                    prop="currency"
                                                    label="币种"
                                                    width="110"
                                                    :show-overflow-tooltip="true">
                                                <template slot-scope="scope">
                                                    {{scope.row.currency | dictname('YLCurrency')}}
                                                </template>
                                            </el-table-column>
                                            <el-table-column
                                                    prop="ycountry"
                                                    label="国家名称"
													:show-overflow-tooltip="true"
                                                    width="120">
                                                <template slot-scope="scope">
                                                    <dictname category="YLCountry_agent"  :v="scope.row.ycountry"/>
                                                </template>
                                            </el-table-column>
                                            <el-table-column
                                                    prop="ycuname"
                                                    label="预测人"
                                                    width="80"
                                                    :show-overflow-tooltip="true">
                                            </el-table-column>
                                            <el-table-column
                                                    prop="ycId"
                                                    label="预测单编号"
                                                    width="160"
                                                    :show-overflow-tooltip="true">
                                            </el-table-column>
                                            <el-table-column
                                                    prop="yhgetdate"
                                                    label="期望送货日期"
                                                    width="300"
                                                    :show-overflow-tooltip="true">
                                                <template scope="scope">
                                                    <el-date-picker
                                                            v-model="scope.row.yhgetdate"
                                                            type="date"
                                                            value-format="yyyy-MM-dd">
                                                    </el-date-picker>
                                                </template>
                                            </el-table-column>
                                            <el-table-column
                                                    prop="yremark"
                                                    label="备注"
                                                    width="300"
                                                    :show-overflow-tooltip="true">
                                                <template slot-scope="scope">
                                                    <el-input
                                                            v-model="scope.row.yremark"
                                                            placeholder="备注"
                                                    >
                                                    </el-input>
                                                </template>
                                            </el-table-column>
                                            <el-table-column
                                                    prop="productDetail"
                                                    label="物料描述"
                                                    :show-overflow-tooltip="true"
                                                    width="200">
                                            </el-table-column>
                                        </el-table>
                                    </div>
                                </div>
                            </div>
                        </el-form>
                    </div>
                </div>
            </div>
            <div class="h-txtCenter h-mrt60">
                <el-button class="h-btn h-bBtn h-bgwhite" @click="cancel">返回</el-button>
                <el-button v-if="zy.status == 0 || zy.status ==''" class="h-btn h-bBtn h-bggreen" @click="save">暂存
                </el-button>
                <el-button v-if="zy.status == 0 || zy.status == 6 || zy.status ==''" class="h-btn h-bBtn h-bgblueQ2"
                            @click="submit('form1')">确认提交
                </el-button>
            </div>
            <!--地址信息-->
            <areaSelect
                    :visible.sync="showdizhiflag"
                    v-if="showdizhiflag"
                    @choseObj="choseDizhi"
            />
        </div>


    </div>
</template>
<script>
    import ss from '../../api/SystemService'
    import big from 'big.js'
    import util from "../../utils/util";

    export default {
        data() {
            return {

                shenpixianshi: [],

                peizhi1: null,

                peizhi2: null,

                peizhi3: null,

                chakanyemian: false,

                yaoshanchude: [],

                tableData3: [],


                toshow: 'orderCreate',
                checked: true,
                showOrhide: false,
                status: 1,
                //带线表单
                value: false,
                newOrBid: true,
                options1: [{
                    code: '2',
                    name: '外部物流'
                }],
                options2: [],
                productOptions: [],
                productType: [],
                cgId: this.$route.query.cgId,
                ywId: this.$route.query.ywid,
                instId: this.$route.query.instid,
				ycId: sessionStorage.getItem('ycId'),
                zy: {
                    numlist: null,
                    suserCode: '',
                    productCate: '',
                    type: '2',
                    productNo: '',
                    waybillType: '',
                    unitPrice: '',
                    count: '',
                    totalPrice: '',
                    detailAddress: '',
                    expectDate: '',
                    productCateName: '',
                    productDes: '',
                    suserName: '',
                    status: 0,
                    proId: '',
                    cgGroupCode: '',
                    province: '',
                    city: '',
                    country: '',
					purchaseOrgCode:"",
                    ycId:'',
                    warehouse:null,
                    receiveUnit:null,
                    receverPhone:null,
                    receiver:null,
                },
                rules: {
                    // suserCode: [
                    //     {required: true, message: '请选择供应商', trigger: 'change'}
                    // ],
                    // productCate: [
                    //     {required: true, message: '请选择产品大类', trigger: 'change'}
                    // ],
                    // productNo: [
                    //     {required: true, message: '请选择产品型号', trigger: 'change'}
                    // ],
                    waybillType: [
                        {required: true, message: '请选择物流类型', trigger: 'change'}
                    ],
                    // count: [
                    //     {required: true, message: '请输入产品数量', trigger: 'change'},
                    //     {pattern: /^[1-9]\d{0,9}$/, message: '请输入10位以内正整数'}
                    // ],
                    expectDate: [
                        {required: true, message: '请选择期货时间', trigger: 'change'},
                    ],
                    receiveUnit: [
                        {required: true, message: '请输入收货单位', trigger: 'blur'}
                    ],
                    receiver: [
                        {required: true, message: '请输入接收人', trigger: 'blur'}
                    ],
                    receverPhone: [
                        {required: true, message: '请输入接收人手机号', trigger: 'blur'},
                        {
                            pattern: /^((13[0-9])|(14[5,7])|(15[0-3,5-9])|(17[0,3,5-8])|(18[0-9])|166|198|199|(147))\d{8}$/,
                            message: '请输入正确的手机号'
                        }
                    ],
                    detailAddress: [
                        {required: true, message: '请输入收货地址', trigger: 'blur'}
                    ],
                    // unitPrice: [
                    //     {required: true, message: '产品单价根据产品型号带出不允许为空', trigger: 'blur'}
                    // ],
                    cgGroupCode: [
                        {required: true, message: '请选择采购组', trigger: 'blur'}
                    ],
					purchaseOrgCode: [
					    {required: true, message: '请选择采购组织', trigger: 'blur'}
					],
                },
                vs: {
                    productId: ''
                },
                showdizhiflag: false,
				q: {
				    pageSize: 100,
				    pageNo: 1,
				    total: 0,
				    id: '',
				},
                ckFlag:false,
            }
        },

        created() {
            this.showzhezhao()


        },

        mounted() {

            //转发页加载
            this.zhuanfachushijiazai();

			//外销预测信息加载
			this.wxycload();
			console.log(sessionStorage.getItem('ycId'),"eeeeeeeeeeeeeeeeeeeeeee")
        },
        methods: {
			wxycload() {
                var yid;
			    if(this.ycId){
                    yid = this.ycId.split(",");
                }
			    if (yid && yid.length > 0) {
                    ss.waixiao.showDingdlist(yid).then(rd => {
                        if (rd && rd.length > 0) {
                            for (var i = 0; i < rd.length; i++) {
                                if (rd[i].protype!=null && rd[i].protype=="OEM"){
                                    var data = {
                                        "productCate":rd[i].cpdlName,
                                        "productNo":rd[i].proCode,
                                        "ycount":rd[i].proNumber,
                                        "productOptions":[{id:rd[i].proCode,levelname:rd[i].proModel}],
                                        "ycountry":rd[i].country,
                                        "ycId":rd[i].id,
                                        "ycuname":rd[i].cuname,
                                        "yremark":rd[i].remark,
                                        "yhgetdate":rd[i].deliveryDate,
                                        "productDetail":rd[i].productDetail

                                    };
                                    this.changeSmail(data,1);
                                    this.tableData3.push(data);
                                }
                                // this.zy.expectDate = rd[i].deliveryDate+" 00:00:00";
                            }
                            for(var j=0;j<this.tableData3.length;j++){
                                this.tableData3[j].count = this.tableData3[j].ycount;
                            }
                        }
                    })
                }

				// if (this.ycId!=null && this.ycId!='') {
				// 	this.q.id = this.ycId;
				// 	ss.waixiao.showDingdlist(this.q).then(rd => {
				// 		if (rd) {
				// 			if (rd.protype!=null && rd.protype=="OEM"){
				// 				var data = {
				// 					"productCate":rd.cpdlName,
				// 					"productNo":rd.proCode,
				// 					"count":rd.proNumber,
				// 					"productOptions":[{id:rd.proCode,levelname:rd.proModel}],
                //                     "Ycountry":rd.country,
                //                     "Yid":rd.id,
                //                     "Ycuname":rd.cuname,
                //                     "Yremark":rd.remark
                //
				// 				};
				// 				this.changeSmail(data,1);
				// 				this.tableData3.push(data);
				// 			}
				// 			this.zy.expectDate = rd.deliveryDate+" 00:00:00";
				// 		}
				// 	})
				// }
			},

            //小类修改，当块数据proProduct[i]-v
            changeSmail(v,flag) {

                v.unitPrice = '';
                this.zy.totalPrice = '';

                v.count = '';

                // this.options1 = [];
                v.proId = '';
                //设置产品型号名称
				if (flag == 1) {
					v.productOptions.forEach((item, index) => {
					    if (v.productNo == item.id) {
					        v.productDes = item.levelname;
					    }
					})
				} else if (flag == 2) {
					v.productOptions.forEach((item, index) => {
					    if (v.productDes == item.levelname) {
					        v.productNo = item.id;
					    }
					})
				}

                // //暂时注释掉获取单价接口
                // var data = {mdmMaterialInfoPrice: {materialid: v, leltypecode: 3}}
                // ss.ProService.product2Detail(data).then(rd => {
                //     if (rd.obj && rd.obj.length > 0) {
                //         this.zy.unitPrice = rd.obj[0].mdmMaterialInfoPrice.value;
                //     } else {
                //         this.zy.unitPrice = '';
                //     }
                // })
                v.options2 = [];
                v.suserCode = '';
                v.suserName = '';
                this.vs = {};
                //获取供应商列表
                if (v.productNo) {
                    this.vs.productId = v.productNo;
                    ss.ProService.supplierByProductId(this.vs).then(rd => {
                        if (rd && rd.length > 0) {
                            //供应商信息
                            v.options2 = rd;
                            v.options2.forEach((item, index) => {
                                let canshu = {};
                                canshu.suserCode = item.finalSupplier;
                                canshu.productNo = v.productNo;
                                //查询供应商商品占比
                                // selectProSupplier(x) {
                                //     this.proSupplier = {};
                                ss.orderCgService.selectProSupplier(canshu).then(rd => {
                                    console.log('我在这儿呀111', rd);
                                    //item.finalSupplierName = item.finalSupplierName + ',产品供应量占比: ' + rd.proportion;
                                })
                                // },;
                            })
                            console.log('我在这儿呀000', v.options2);

                            this.$set(v.options2, rd);
                        }
                    })
                }
            },
            //供应商名字
            changeSup(v) {
			    var totalPrice = 0;
                v.options2.forEach((item, index) => {
                    if (v.suserCode == item.finalSupplier) {

                        v.suserName = item.finalSupplierName;
                        v.unitPrice = item.unitPrice;
                        v.proId = item.contractId;
                        v.currency = item.currency;
                        // if (item.wuliufangshi == 3) {
                        //     this.options1 = this.$store.getters.dicts["waybill_type"];
                        // }else{
                        //     console.log(this.$store.getters.dictname("waybill_type",item.wuliufangshi))
                        //     this.options1 = [{"code": item.wuliufangshi,"name":this.$store.getters.dictname("waybill_type",item.wuliufangshi)}];
                        // }
                        this.tableData3.forEach((elements,index)=>{
                            console.log("qqqqqqqqqqqqq",elements.count)
                            if (totalPrice == 0) {
                                totalPrice = elements.unitPrice * elements.count;
                            } else {
                                totalPrice = totalPrice + (elements.unitPrice * elements.count);
                            }
                        })
                    }
                })
                this.zy.totalPrice = totalPrice;
            },


            showzhezhao() {
                ss.salesList.toshow(this.toshow).then(rd => {
                    console.log(rd)
                    if (rd == false) {
                        this.showOrhide = false;
                    } else {
                        this.showOrhide = true;
                    }
                })
            },
            //转发加载
            zhuanfachushijiazai() {

                if (this.cgId != null || (this.ywId != null && this.instId != null)) {

                    var yewuid = this.cgId != null ? this.cgId : this.ywId;

                    //查看订单详情
                    ss.orderCgService.caigouselectById(yewuid).then(rd => {
                        if (rd.obj) {
                            console.log("123123123",rd.obj)
                            //加载自己信息
                            this.jiazaiobjxinxi(rd.obj);
                            //若兄弟信息存在
                            if (rd.obj.orderCgList) {
                                //加载兄弟信息
                                this.jiazaixiongdi(rd.obj.orderCgList);
                            }
                        }

                    })


                }

            },


            //加载当前自己的原始信息
            jiazaiobjxinxi(q) {

                //初始化默认数据
                this.zy = q;

            },

            //增加行
            adds() {

                var list = {

                    productCateName: '',
                    productDes: '',
                    productCate: '',
                    productNo: '',
                    productOptions: [],
                    suserCode: '',
                    suserName: '',
                    options2: [],
                    unitPrice: null,
                    count: null,
                    proId: '',
                    //预测单号c
                    ycId: '',
                    ycountry: '',
                    ycuname: '',
                    yremark: '',
                    yhgetdate: '',


                }


                this.tableData3.push(list)

            },


            //加载兄弟信息
            jiazaixiongdi(q) {

                var orderCg = {

                    instidlist: [],
                    taskId: this.$route.query.taskid,

                };

                for (var s in q) {

                   // this.adds();

                    orderCg.instidlist.push(q[s].instid)

                }
                ss.orderCgService.shuaixuanInstid(orderCg).then(rd => {

                    console.log(rd, '可以显示的，需要审批的')

                    //过滤存在
                    if (JSON.stringify(rd.obj) != '{}' && this.$route.query.taskid) {

                        this.shenpixianshi = rd.obj;

                        var qq = [];

                        for (var c in q) {

                            for (var d in rd.obj) {

                                if (q[c].instid == rd.obj[d]) {

                                    qq.push(q[c])

                                }

                            }

                        }

                        this.tableData3 = [];

                        for (var c in qq) {

                            this.tableData3[c] = qq[c];

                        }

                    } else {

                        for (var c in q) {

                            this.tableData3[c] = q[c];

                        }

                    }


                    for (var m in this.tableData3) {


                        this.tableData3[m].productOptions = this.tableData3[m].product2OemSelectresult;


                        for (var d in this.tableData3[m].productType) {

                            if (d == 'id' && this.tableData3[m].productCate == d) {

                                this.tableData3[m].productCateName = this.tableData3[m][d].levelname;

                            }

                        }


                        this.tableData3[m].productOptions = this.tableData3[m].product2Selectresult;


                        if(this.tableData3[m].productOptions){
                            //设置产品型号名称
                            this.tableData3[m].productOptions.forEach((item, index) => {
                                if (this.tableData3[m].productNo == item.id) {
                                    this.tableData3[m].productDes = item.levelname;
                                }
                            })
                        }



                        this.vs.productId = this.tableData3[m].productNo;


                        this.tableData3[m].options2 = this.tableData3[m].supplierByProductIdresult;


                    }


                })

            },


            //清空选择型号
            qingkong() {

                this.$msg.confirm("确认清空？", () => {

                    this.f.numlist = null;

                })

            },
            closeIt() {
                this.showOrhide = false;
                if (this.checked) {
                    ss.salesList.toshow(this.toshow, this.checked).then(rd => {
                        console.log(rd)
                        this.showOrhide = false;
                    })
                } else {
                    ss.salesList.toshow(this.toshow, this.checked).then(rd => {
                        console.log(rd)
                        this.showOrhide = false;
                    })
                }
            },
            nextStep(i) {
                console.log(i)
                if (this.status == 1) {
                    document.documentElement.scrollTop = 200;
                } else if (this.status == 2) {
                    this.status = 3;
                } else if (this.status == 3) {
                    if (this.checked) {
                        ss.salesList.toshow(this.toshow, this.checked).then(rd => {
                            console.log(rd)
                            this.showOrhide = false;
                        })
                    } else {
                        ss.salesList.toshow(this.toshow, this.checked).then(rd => {
                            console.log(rd)
                            this.showOrhide = false;
                        })
                    }

                }
            },
            changeNum(v) {
				var total=0;
				for(var i=0;i<this.tableData3.length;i++){
					var data = this.tableData3[i];
					if(data.count && data.unitPrice){
						total=new big(data.count).times(data.unitPrice).plus(total);
					}
				}
				this.zy.totalPrice = total;
            },
            cancel() {
                this.$router.push("purchaselist");
            },


            submit(form) {
                var flag = false;
                this.$refs[form].validate((valid) => {
                    if (valid) {
                        flag = true;
                    } else {
                        return false;
                    }
                });
                //判断数据完整
                if (flag) {
                    if (this.shoudongpanduan()) {

                        this.$msg.msge("请先填写完整信息并保证信息准确性")

                    } else {

                        this.newtijiao();

                    }
                }

            },


            //手动判断
            shoudongpanduan() {

                var s = false;

                for (var c in this.tableData3) {

                    if (

                        (this.tableData3[c].productCate == null || this.tableData3[c].productCate == '') ||
                        (this.tableData3[c].suserCode == null || this.tableData3[c].suserCode == '') ||
                        (this.tableData3[c].productNo == null || this.tableData3[c].productNo == '') ||
                        (this.tableData3[c].count == null || this.tableData3[c].count == '') ||
                        (this.tableData3[c].unitPrice == null || this.tableData3[c].unitPrice == '')

                    ) {

                        s = true;

                    } else {

                        let ex = /^[1-9]\d{0,9}$/
                        if (!ex.test(this.tableData3[c].count)) {
                            s = true;
                        }

                    }


                }

                return s;

            },


            //构造参数
            gouzaocanshu() {

                var entitylist = [];

                for (var c in this.tableData3) {

                    entitylist.push({

                        numlist: this.zy.numlist,
                        type: this.zy.type,
                        waybillType: this.zy.waybillType,
                        detailAddress: this.zy.detailAddress,
                        expectDate: this.zy.expectDate,
                        status: this.zy.status,
                        cgGroupCode: this.zy.cgGroupCode,
						purchaseOrgCode: this.zy.purchaseOrgCode,
                        province: this.zy.province,
                        city: this.zy.city,
                        country: this.zy.country,
                        receiver: this.zy.receiver,
                        receverPhone: this.zy.receverPhone,
                        receiveUnit: this.zy.receiveUnit,
                        warehouse: this.zy.warehouse,


                        instid: this.instId || null,
                        cgId: this.tableData3[c].cgId || '',
                        zhubiaoid: this.tableData3[c].zhubiaoid || '',
                        productCateName: this.$getDictName("product_level",this.tableData3[c].productCate),
                        productDes: this.tableData3[c].productDes,
                        productCate: this.tableData3[c].productCate,
                        productNo: this.tableData3[c].productNo,
                        suserCode: this.tableData3[c].suserCode,
                        suserName: this.tableData3[c].suserName,
                        unitPrice: this.tableData3[c].unitPrice,
                        count: this.tableData3[c].count,
                        proId: this.tableData3[c].proId,
                        totalPrice:new big(this.tableData3[c].unitPrice).times(this.tableData3[c].count),
                        //预测单号c
                        ycId: this.tableData3[c].ycId,
                        ycountry: this.tableData3[c].ycountry,
                        ycuname: this.tableData3[c].ycuname,
                        yremark: this.tableData3[c].yremark,
                        yhgetdate: this.tableData3[c].yhgetdate,
                        currency: this.tableData3[c].currency,
                    })
                    console.log("111111111111",entitylist)
                }

                return entitylist;

            },


            //新list提交方法
            newtijiao() {
                var flag = false;
                this.$refs['form1'].validate((valid) => {
                    if (valid) {
                        flag = true;
                    } else {
                        this.$msg.msge("请完善采购订单数据！");
                        return false;
                    }
                });
                if (!flag) {
                    return;
                }
				this.changeNum();
                this.zy.expectDate = util.riQi6(this.zy.expectDate)

                //审批驳回提交
                if (this.ywId != null && this.instId != null) {
                    ss.orderCgService.renewOrderCglist(this.gouzaocanshu()).then(rd => {
                        if (rd.f) {
                            this.$msg.msgs("提交成功！");
                            this.$store.dispatch('searchTasktotal');
                            this.$router.push("purchaselist");
                        } else {
                            this.$msg.msge("提交失败！" + rd.msg);
                        }
                    })

                    //普通提交
                } else {

                    this.zy.status = 1;
                    ss.orderCgService.createCgOrderlist(this.gouzaocanshu()).then(rd => {
                        if (rd.f) {
                            this.$msg.msgs("提交成功！");
                            this.$router.push("purchaselist");
                        } else {
                            this.zy.status = "";
                            this.$msg.msge("提交失败！" + rd.msg);
                        }
                    })
                }
            },


            //旧蔡工单提交方法
            oldtijiao() {
                var flag = false;
                this.$refs['form1'].validate((valid) => {
                    if (valid) {
                        flag = true;
                    } else {
                        this.$msg.msge("请完善采购订单数据！");
                        return false;
                    }
                });
                if (!flag) {
                    return;
                }
                this.zy.expectDate = util.riQi6(this.zy.expectDate)

                //审批提交
                if (this.ywId != null && this.instId != null) {
                    ss.orderCgService.renewOrderCg(this.zy).then(rd => {
                        if (rd.f) {
                            this.$msg.msgs("提交成功！");
                            this.$store.dispatch('searchTasktotal');
                            this.$router.push("purchaselist");
                        } else {
                            this.$msg.msge("提交失败！" + rd.msg);
                        }
                    })

                    //普通提交
                } else {
                    this.zy.status = 1;
                    ss.orderCgService.createCgOrder(this.zy).then(rd => {
                        if (rd.f) {
                            this.$msg.msgs("提交成功！");
                            this.$router.push("purchaselist");
                        } else {
                            this.$msg.msge("提交失败！" + rd.msg);
                        }
                    })
                }
            },

            //暂存
            save() {

                this.savenew();

            },


            //新暂存list
            savenew() {

                this.zy.status = 0;
                if (this.zy.expectDate) {
                    this.zy.expectDate = util.riQi6(this.zy.expectDate)
                }
                console.log(this.gouzaocanshu(),"//////////////");
                ss.orderCgService.createCgOrderlist(this.gouzaocanshu()).then(rd => {
                    if (rd.f) {
                        this.$msg.msgs("提交成功！");
                        this.$router.push("purchaselist");
                    } else {
                        this.zy.status = "";
                        this.$msg.msge("提交失败！" + rd.msg);
                    }
                })
            },


            //旧蔡工单暂存
            saveold() {

                this.zy.status = 0;
                if (this.zy.expectDate) {
                    this.zy.expectDate = util.riQi6(this.zy.expectDate)
                }
                ss.orderCgService.createCgOrder(this.zy).then(rd => {
                    if (rd.f) {
                        this.$msg.msgs("提交成功！");
                        this.$router.push("purchaselist");
                    } else {
                        this.$msg.msgs("提交失败！" + rd.msg);
                    }
                })

            },


            choseDizhi(obj) {
                this.zy.detailAddress = obj.quobj.namepath;
                if (obj.zhenobj) {
                    this.zy.detailAddress = obj.zhenobj.namepath;
                }
                this.zy.detailAddress = this.zy.detailAddress + obj.addrdetail;
                this.zy.province = obj.shengobj.name;
                this.zy.city = obj.shiobj.name;
                this.zy.country = obj.quobj.name;
                // this.order.addressCode = obj.id;
                // this.order.areaId = obj.id;
                // this.order.toAddress = obj.quobj.namepath;
                // if(obj.zhenobj){
                //     this.order.toAddress = obj.zhenobj.namepath;
                // }
                // this.order.toAddress = this.order.toAddress + obj.addrdetail
                // this.order.toProvincesCode = obj.shengobj.name;
                // this.order.toCityCode = obj.shiobj.name;
                this.showdizhiflag = false;
            },
            //选择地址
            selectAreadialog() {
                this.showdizhiflag = true;
            },
            changeCgGroup(){
                var category = 'cg_org_group';
                var code = this.zy.purchaseOrgCode;
                if(this.zy.purchaseOrgCode == '1R60'){
                    this.ckFlag = true;
                }else {
                    this.ckFlag = false;
                }
                //根据选中的采购组织编码获取采购组
                ss.Dictservice.getDictByCateCode(category,code).then(rd =>{
                    this.zy.cgGroupCode = rd.name;
                })
                var data = {}
                data.purchaseOrgCode = this.zy.purchaseOrgCode;
                data.kuwei = '青岛库';
                //获取默认收货信息
                ss.orderCgService.getDefaultCg(data).then(rd => {
                    if(rd.f){
                        this.zy.detailAddress = rd.msg.receiveAddress;
                        this.zy.receiver = rd.msg.receiver;
                        this.zy.receiveUnit = rd.msg.receiveUnit;
                        this.zy.receverPhone = rd.msg.receiverPhone;
                    }
                })
            },
            changeWarehouse(){
                var data = {}
                data.purchaseOrgCode = this.zy.purchaseOrgCode;
                data.kuwei = this.zy.warehouse;
                //获取默认收货信息
                ss.orderCgService.getDefaultCg(data).then(rd => {
                    if(rd.f){
                        this.zy.detailAddress = rd.msg.receiveAddress;
                        this.zy.receiver = rd.msg.receiver;
                        this.zy.receiveUnit = rd.msg.receiveUnit;
                        this.zy.receverPhone = rd.msg.receiverPhone;
                        console.log("this.zy",this.zy)
                    }
                })
            },
        },

    }
</script>
<style>
    .dingdan2.h-formLine .el-form-item__label {
        width: 35%;
        text-align: right;
    }

    .dingdan2.h-formLine .el-form-item__content {
        width: 65%;
    }

    .dingdan2.h-formLine .h-elformWrap-2 {
        width: 33.333%;
        padding-right: 0.5rem
    }
</style>
<style scoped lang="scss">
    .bottomTip {
        position: absolute;
        left: 49.7%;
        bottom: 0.3rem;
        transform: translateX(-50%);
    }

    .newtext {
        font-size: 0.28rem;
        color: white;
        position: absolute;
        top: 0.2rem;
        left: 50%;
        transform: translateX(-50%);
        font-weight: bold;
        text-shadow: 1px 1px 4px #2785E7;
        z-index: 2;
    }

    .leaderBox {
        width: 100%;
        height: 100%;
        background-color: rgba(0, 0, 0, 0.4);
        position: fixed;
        z-index: 99999;
        overflow: hidden;
        top: 0;
        left: 0;

        .leaderbg {
            width: 100%;
            height: 100%;

        }

        .steps {
            position: absolute;
            z-index: 1;

        }

        .step1 {
            top: 2.1rem;
            left: 3.3rem;
            width: 15rem;
            height: 2rem;
        }

        .step2 {
            top: 6.9rem;
            right: 7.8rem;
            width: 4.4rem;
            height: 1rem;
        }

        .step3 {
            top: 6.9rem;
            right: 2.9rem;
            width: 1.9rem;
            height: 1rem;
        }

        .stepbtn {
            width: 1.9rem;
            height: 0.6rem;
            border: 0.03rem solid #FFFFFF;
            background-color: rgba(0, 0, 0, 0.1);
            border-radius: 5px;
            display: flex;
            justify-content: center;
            line-height: 0.5rem;
            position: absolute;
            z-index: 99;
            bottom: 0.75rem;
            left: 50%;
            transform: translateX(-50%);
            font-size: 0.27rem;
            letter-spacing: 2px;
            color: white;
            cursor: pointer;
        }

        .closeIt {
            width: 0.3rem;
            height: 0.3rem;
            position: absolute;
            top: 0.2rem;
            right: 0.2rem;
            cursor: pointer;
        }
    }
</style>

